export class AbortError extends Error {
  constructor() {
    super('Simulation Aborted');
    // Matches the native DOMException name, so the `error.name === 'AbortError'`
    // checks in api.ts treat a cancel during retry backoff like any other abort
    // instead of logging it as a failure.
    this.name = 'AbortError';
  }
}

export class QuotaExceededError extends Error {
  constructor(
    message = 'Usage limit reached. Purchase PS tokens to continue.',
  ) {
    super(message);
    this.name = 'QuotaExceededError';
  }
}
